
import React from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import { TableCell, TableRow } from "@mui/material";
import PrimaryTable from "../PrimaryTable";
import { globalAddressHead } from "../../../../config/constant";
import clsx from "clsx";
import { NavLink } from "react-router-dom";


export const AddressTable = (props) => {
    const { details, loader, onRequestSort, sortOrder, sortBy, selectAddress } = props;

    const classes = customStyles();
    return (
        <PrimaryTable
            heads={globalAddressHead}
            customClasses={classes.addressTable}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            width={true}
            component={
                <>
                    {
                        loader === false && details && details.length > 0 && details.map((data, i) => (
                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                <TableCell>
                                    <div>{data.businessName ? data.businessName : data.contactName ? data.contactName : '---'}</div>
                                    <div className={clsx(classes.subTitle)}>{'Younote ID'}</div>
                                    <div>{data?.business?.serialNo || '---'}</div>
                                </TableCell>
                                <TableCell>{data.mobile}</TableCell>
                                <TableCell>
                                    {data.email}
                                    <div className={clsx(classes.subTitle)}>{'Address'}</div>
                                    <div className={clsx(classes.addressPadding)}>{`${data.address1 ? data.address1 + ',' : '---,'} ${data.area ? data.area.name + ',' : ''} ${data.city ? data.city.name + ',' : ''} ${data.pincode ? data.pincode.code + ',' : ''} ${data.state ? data.state.name + ',' : ''} ${data.country ? data.country.name : ''}`}</div>

                                </TableCell>
                                <TableCell><NavLink to={'#'} onClick={() => selectAddress(data)} className={clsx(classes.color, classes.bold)}><span className={classes.actionColumn}>{'Select'}</span></NavLink></TableCell>
                            </TableRow>
                        ))
                    }
                    {
                        loader === false && details && details.length === 0 && (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={4}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                            </TableRow>
                        )
                    }
                    {
                        loader === true && (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={4}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        )
                    }
                </>
            }
        />
    )
}